import { createSlice } from "@reduxjs/toolkit";
import { initialState } from "../initialState.js";
import { getChangeLogForCurrentVersion } from "./operations.js";

const changeLogSlice = createSlice({
  name: "changeLog",
    initialState: {
    ...initialState.changeLog,
  },
    reducers: {
    markAsRead(state) {
      if (state.currentVersionChanges) {
        state.currentVersionChanges.is_read = true;
      }
    },
  },
  extraReducers: builder =>
    builder
        .addCase(getChangeLogForCurrentVersion.pending, state => {
            state.isCHangeLogLoading = true;
            state.error = null;
        })
        .addCase(getChangeLogForCurrentVersion.fulfilled, (state, action) => {
            state.isCHangeLogLoading = false;
            state.currentVersionChanges = action.payload;
        })
        .addCase(getChangeLogForCurrentVersion.rejected, (state, action) => {
            state.isCHangeLogLoading = false;
            state.error = action.payload;
        }),
    
});

export const { markAsRead } = changeLogSlice.actions;
export default changeLogSlice.reducer;
